import BLANK from "../images/BLANK_1.png";
import CORP from "../images/CORP_1.png";
import PLUS from "../images/PLUS_1.png";
import SRS_1 from "../images/SRS_1.png";

/** Matches `parentOrganizationClientId` / Roof Hub SRS flow in edit & apply. */
export const SRS_INTEGRATOR_PARENT_CLIENT_ID = "SRSIntegrator";

/**
 * Org column: SRS Integrator parent → Roof Hub badge; else same as legacy getCorp.
 */
export function orgColumnIcon(
  parentOrganizationClientId,
  integratorId,
  bundleClientId
) {
  if (
    String(parentOrganizationClientId || "").trim() ===
    SRS_INTEGRATOR_PARENT_CLIENT_ID
  ) {
    return SRS_1;
  }
  if (integratorId) return CORP;
  if (bundleClientId) return PLUS;
  return BLANK;
}

export function orgColumnAlt(
  parentOrganizationClientId,
  integratorId,
  bundleClientId
) {
  if (
    String(parentOrganizationClientId || "").trim() ===
    SRS_INTEGRATOR_PARENT_CLIENT_ID
  ) {
    return "SRS Integrator (Roof Hub)";
  }
  return integratorId ? integratorId : bundleClientId ? bundleClientId : "";
}

/** Native `title` tooltip when the Org column shows the Roof Hub (SRS) badge. */
export function orgColumnTooltip(
  parentOrganizationClientId
) {
  if (
    String(parentOrganizationClientId || "").trim() ===
    SRS_INTEGRATOR_PARENT_CLIENT_ID
  ) {
    return "Roof Hub partner (SRS Integrator)";
  }
  return undefined;
}
